import { HttpService } from '../services/http/http.service';
import { Api } from './api';
import { z } from 'zod';

export const DISCLOSE_SECRETS = 'disclose-secrets';
export const DISCLOSURES = 'disclosures';

export class DealerApi {
  private api: Api;

  private constructor(url: string, httpService: HttpService) {
    this.api = new Api(url, httpService);
  }

  static request(url: string, httpService: HttpService) {
    return new DealerApi(url, httpService);
  }

  async existingSecrets(dealId: string) {
    const response = await this.api.get<ApiResponseDisclosures>(`${DISCLOSURES}/${dealId}`);
    if (!DealerApi.isApiResponseDisclosures(response)) {
      console.warn(`${DISCLOSURES} api response has changed`);
    }

    return response;
  }

  async disclose(
    dealId: string,
    indexes: number[],
    gameStateHash: string,
    disclosedSecrets: number,
  ) {
    const response = await this.api.post<
      ApiResponseSecretsDisclosed,
      {
        dealId: string;
        indexes: number[];
        gameStateHash: string;
        disclosedSecrets: number;
      }
    >(DISCLOSE_SECRETS, { dealId, indexes, gameStateHash, disclosedSecrets }, [2000]);

    if (!DealerApi.isApiResponseSecretsDisclosed(response)) {
      console.warn(`${DISCLOSE_SECRETS} api response has changed`);
    }

    return response;
  }

  static isApiResponseDisclosures(obj: unknown): obj is ApiResponseDisclosures {
    return ApiResponseDisclosuresSchema.safeParse(obj).success;
  }

  static isApiResponseSecretsDisclosed(obj: unknown): obj is ApiResponseDisclosures {
    return ApiResponseSecretsDisclosedSchema.safeParse(obj).success;
  }
}

export const ApiResponseDisclosuresSchema = z.object({
  data: z.object({
    disclosures: z.object({ index: z.number(), value: z.number() }).array(),
  }),
});

export type ApiResponseDisclosures = z.infer<typeof ApiResponseDisclosuresSchema>;

export const ApiResponseSecretsDisclosedSchema = z.object({
  data: z.object({
    secrets: z.object({ index: z.number(), value: z.number() }).array(),
  }),
});

export type ApiResponseSecretsDisclosed = z.infer<typeof ApiResponseSecretsDisclosedSchema>;
